(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-tabs"] && !Shopify.designMode) return;
  try {
    

// タブ切り替え（フェード）
document.querySelectorAll('.category-tab-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const idx = btn.dataset.index;

    document.querySelectorAll('.category-tab-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    const currentPanel = document.querySelector('.category-tab-panel.active');
    if (currentPanel) {
      currentPanel.style.opacity = '0';
      setTimeout(() => {
        currentPanel.classList.remove('active');
        currentPanel.style.display = 'none';

        const nextPanel = document.querySelector(`.category-tab-panel[data-index="${idx}"]`);
        nextPanel.style.display = 'block';
        nextPanel.style.opacity = '0';
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            nextPanel.style.transition = 'opacity 0.3s ease';
            nextPanel.style.opacity = '1';
            nextPanel.classList.add('active');
          });
        });
      }, 300);
    }
  });
});

// ドラッグ＆スライダー（PC・スマホ慣性あり）
document.querySelectorAll('.product-grid').forEach(grid => {

  // --- PC用 ---
  let isDown = false;
  let startX, scrollLeft;
  let hasDragged = false;
  let lastX = 0, lastTime = 0;
  let velocity = 0;
  let rafId = null;

  function applyInertia() {
    velocity *= 0.92;
    if (Math.abs(velocity) < 0.5) { velocity = 0; return; }
    grid.scrollLeft += velocity;
    rafId = requestAnimationFrame(applyInertia);
  }

  grid.addEventListener('mousedown', (e) => {
    if (e.button !== 0) return;
    isDown = true;
    hasDragged = false;
    velocity = 0;
    if (rafId) cancelAnimationFrame(rafId);
    grid.classList.add('dragging');
    grid.style.scrollSnapType = 'none';
    startX = e.pageX - grid.offsetLeft;
    scrollLeft = grid.scrollLeft;
    lastX = e.pageX;
    lastTime = Date.now();
    e.preventDefault();
  });

  grid.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - grid.offsetLeft;
    const walk = (x - startX) * 1.2;
    if (Math.abs(walk) > 5) hasDragged = true;
    grid.scrollLeft = scrollLeft - walk;

    const now = Date.now();
    const dt = now - lastTime;
    if (dt > 0) velocity = (lastX - e.pageX) / dt * 16;
    lastX = e.pageX;
    lastTime = now;
  });

  grid.addEventListener('mouseup', () => {
    if (!isDown) return;
    isDown = false;
    grid.classList.remove('dragging');
    grid.style.overflowX = 'auto';
    rafId = requestAnimationFrame(applyInertia);
  });

  grid.addEventListener('mouseleave', () => {
    if (!isDown) return;
    isDown = false;
    grid.classList.remove('dragging');
    grid.style.overflowX = 'auto';
    rafId = requestAnimationFrame(applyInertia);
  });

  grid.addEventListener('click', (e) => {
    if (hasDragged) {
      e.preventDefault();
      e.stopPropagation();
      hasDragged = false;
    }
  }, true);

  // --- スマホ用 ---
  let touchStartX, touchStartY, touchScrollLeft;
  let touchLastX = 0, touchLastTime = 0;
  let touchVelocity = 0;
  let touchRafId = null;
  let isHorizontal = null;

  function applyTouchInertia() {
    touchVelocity *= 0.92;
    if (Math.abs(touchVelocity) < 0.3) { touchVelocity = 0; return; } // ← 終了条件
    grid.scrollLeft += touchVelocity;
    touchRafId = requestAnimationFrame(applyTouchInertia);
  }

  grid.addEventListener('touchstart', (e) => {
    hasDragged = false;
    isHorizontal = null;
    touchVelocity = 0;
    if (touchRafId) cancelAnimationFrame(touchRafId);
    grid.style.scrollSnapType = 'none';
    touchStartX = e.touches[0].pageX;
    touchStartY = e.touches[0].pageY;
    touchScrollLeft = grid.scrollLeft;
    touchLastX = e.touches[0].pageX;
    touchLastTime = Date.now();
  }, { passive: true });

  grid.addEventListener('touchmove', (e) => {
    const dx = e.touches[0].pageX - touchStartX;
    const dy = e.touches[0].pageY - touchStartY;

    if (isHorizontal === null) {
      isHorizontal = Math.abs(dx) > Math.abs(dy);
    }

    if (isHorizontal) {
      e.preventDefault();
      const x = e.touches[0].pageX - grid.offsetLeft;
      const walk = (x - (touchStartX - grid.offsetLeft)) * 1.0;
      if (Math.abs(walk) > 5) hasDragged = true;
      grid.scrollLeft = touchScrollLeft - walk;

      const now = Date.now();
      const dt = now - touchLastTime;
      if (dt > 0) touchVelocity = (touchLastX - e.touches[0].pageX) / dt * 40; // 初速
      touchLastX = e.touches[0].pageX;
      touchLastTime = now;
    }
  }, { passive: false });

  grid.addEventListener('touchend', () => {
    grid.style.overflowX = 'auto';
    grid.style.scrollSnapType = 'none';
    if (isHorizontal) {
      touchRafId = requestAnimationFrame(applyTouchInertia);
    }
    isHorizontal = null;
  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
